import {Routes, Route, Outlet, Navigate} from 'react-router-dom'
import {PageLink} from '../../../_metronic/layout/core'
import RoutesList from './RoutesList'
import ConfigureRoute from './components/ConfigureRoute'
import {ConfigRoutesProvider} from './ConfigRoutesProvider'

export const routesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Route Configure',
    path: '/routes/configure-list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const RoutesConfig = () => (
  <Routes>
    <Route
      element={
        <ConfigRoutesProvider>
          {/* <ToolbarWrapper /> */}
          <Outlet />
        </ConfigRoutesProvider>
      }
    >
      <Route
        path='configure-list'
        element={
          <>
            {/* <PageTitle breadcrumbs={routesBreadcrumbs}>Dashboard</PageTitle> */}
            <RoutesList />
          </>
        }
      />
      <Route
        path='/:type/:id?'
        element={
          <>
            {/* <PageTitle breadcrumbs={routesBreadcrumbs}>Dashboard</PageTitle> */}
            <ConfigureRoute />
          </>
        }
      />
      <Route index element={<Navigate to='/routes/configure-list' />} />
    </Route>
  </Routes>
)

export default RoutesConfig
